import { PayloadTransactionSummary } from "../types";
import { roundCurrency } from "./roundCurrency";

export function getTransactionsTotal(transactions: PayloadTransactionSummary[] | undefined) {
  if (!transactions) return 0
  return roundCurrency(transactions.reduce((sum, t) => sum + (t.amount), 0))
}

export function getCashToCloseRemaining(
  cashToCloseAmount: number | string | undefined | null,
  transactions: PayloadTransactionSummary[] | undefined
): number {
  return roundCurrency(Number(cashToCloseAmount ?? 0) - getTransactionsTotal(transactions))
}
